<script lang="ts">
  import LottiePlayer from "@/components/lottie-player.svelte";
  import SafeHtml from "@/components/safe-html.svelte";
  import { formatDuration } from "@script/date";
  import { translate as tr } from "@script/i18n";
  import { getMinutesPracticedOnDay, getPracticedWeekDays, getStats, type Stats } from "@script/session.ts";
  import { capitalize, showFireworks } from "@script/utils";
  import { Block } from "framework7-svelte";
  import { onMount } from "svelte";
  import Ribbon from "../../components/ribbon.svelte";
  import WeekBadge from "../../components/week-badge.svelte";

  let fireworkEl: HTMLSpanElement;
  let stats: Stats = getStats();

  const todayDate = new Date();
  const practicedWeekDays: Map<string, boolean> = getPracticedWeekDays(stats, todayDate, false);

  // reactive statements
  const minPracticedToday: number = getMinutesPracticedOnDay(stats, todayDate);
  const totalDays: number = stats.totalDays;

  // const axisDateFormat = Intl.DateTimeFormat(language, {
  //   month: "short",
  //   year: "numeric"
  // });
  // const tooltipDateFormat = Intl.DateTimeFormat(language, {
  //   month: "long",
  //   year: "numeric"
  // });

  const formatThousands = (num: number): string => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    } else {
      return num.toString();
    }
  };

  let isOpen = false;
  onMount(() => {
    showFireworks(fireworkEl, { delay: 600 });
    setTimeout(() => {
      isOpen = true;
    }, 600);
  });
</script>

<div class="page-journal">
  <Block>
    <div class="text-align-center top-results">
      <div style="margin-top: -36px; margin-bottom: -36px;">
        <LottiePlayer name="trophy" playing={isOpen} autoplay={false} loop={false} speed={0.6} height={"196px"} />
      </div>
      <Ribbon text={totalDays} />
      <span class="text-total-days" bind:this={fireworkEl}>
        {`${tr("stats.total")} ${tr("common.day", { count: totalDays })}`}
      </span>
    </div>
  </Block>

  <Block style="margin-top: 8px">
    <div class="display-flex justify-content-center align-items-center">
      <WeekBadge checkedDays={practicedWeekDays} animate={isOpen}></WeekBadge>
    </div>
    <div class="text-align-center">
      <span class="text-week">{capitalize(tr("stats.week"))}</span>
    </div>
  </Block>

  <p />
  <Block>
    <div class="grid grid-cols-2 grid-gap">
      <div class="text-align-center">
        <span class="text-large">{stats.currentStreak}</span>
        <br />
        <span class="text-small">{`${tr("stats.days_in_row", { count: stats.currentStreak })}`}</span>
      </div>

      <div class="text-align-center">
        <span class="text-large">{minPracticedToday}</span>
        <br />
        <span class="text-small">{`${tr("common.minute", { count: minPracticedToday })} ${tr("common.today")}`}</span>
      </div>

      <div class="text-align-center">
        <span class="text-large">{formatThousands(stats.totalMins)}</span>
        <br />
        <span class="text-small">{`${tr("common.minute", { count: minPracticedToday })} ${tr("stats.total")}`}</span>
      </div>

      <div class="text-align-center">
        <span class="text-large">{formatThousands(stats.totalBreaths)}</span>
        <br />
        <span class="text-small">{tr("stats.total_breaths")}</span>
      </div>
    </div>
  </Block>
  <Block style="margin-top: 24px">
    <p class="text-congrats">
      <span class="time-result">
        <SafeHtml
          text={tr("stats.amazing_results", {
            duration: formatDuration(Math.floor(stats.totalMins * 60 * 1000))
          })} />
      </span>
      <span style="color: var(--f7-block-title-text-color);">{@html tr("stats.continue_pep_talk")}</span>
    </p>
    <p>
      <span>
        <SafeHtml text={tr("about.recommendation")} />
      </span>
    </p>
  </Block>
</div>

<style>
  .text-congrats {
    font-size: 1.1em;
    text-align: center;
  }

  .text-week {
    font-size: 0.8em;
    font-weight: bold;
    opacity: 0.8;
  }

  .text-total-days {
    font-size: 1em;
    font-weight: bold;
  }

  .text-large {
    font-size: 2em;
    font-weight: bold;
  }

  :global(.time-result > strong) {
    font-size: 1.1em;
  }

  :global(.page-journal .block) {
    margin: 0;
  }
</style>
